import type { WalletRiskLevel } from '../model/types';

export const isAttentionRisk = (level: WalletRiskLevel): boolean =>
  level === 'high' || level === 'critical';
